const { createElem } = require('./helpers');

function handleTileUpdates() {
  function truncate(n, useWordBoundary) {
    if (this.length <= n) { 
      return this; 
    }
    var subString = this.substr(0, n - 1);
    return (useWordBoundary 
       ? subString.substr(0, subString.lastIndexOf(' ')) 
       : subString) + "...";
  }

  function truncateText(tile) {
    const descElem = tile.querySelector('h4');

    if (!descElem) {
      return;
    }

    const descString = descElem.innerText;

    if (descString.length > 100) {
      descElem.innerText = truncate.apply(descString, [100, true]);
    }
  }

  function getHighResImage(tile) {
    const imageContainer = tile.querySelector('.img');

    if (!imageContainer) {
      return;
    }

    let imgSrc = imageContainer.querySelector('img').getAttribute('src');
    
    if (!/mediaproxy/.test(imgSrc)) {
      imageContainer.style.background = `50% / cover no-repeat url('${imgSrc}')`;
      return;
    }
    
    const newImg = decodeURIComponent(imgSrc.split('url=')[1]);
    imgSrc = newImg.split('&')[0].split('?')[0];
    imageContainer.style.background = `50% / cover no-repeat url('${imgSrc}')`;
  }

  function updateShareAndLabel(tile) {
    const shareElement = tile.querySelector('.share-single');

    if (shareElement) {
      tile.appendChild(shareElement);
    }
  }

  function updateLabelPosition(tile) {
    const labelElem = tile.querySelector('a.view');
    const target = tile.querySelector('.description');

    target.appendChild(labelElem);
  }

  function handleCustomerStoryTile(tile) {
    const { tags, id } = tile.dataset;
    const { customerStoryTiles } = window.obData;
    let customerLogoSrc;

    if (tags.indexOf('customer-story') === -1) {
      return;
    }
  
    for (const tileId in customerStoryTiles) {
      let match = false;

      if (tileId === id) {
        match = true;
        customerLogoSrc = customerStoryTiles[tileId];
        break;
      }

      if (match) {
        break;
      }
    }

    if (customerLogoSrc === '') {
      return;
    }

    const target = tile.querySelector('.description');
    const imgElem = createElem('img', { src: customerLogoSrc });
    target.insertBefore(imgElem, target.firstChild);

    const label = tile.querySelector('a.view');
    label.innerText = 'Read story';
  }

  function handlePodcastTile(tile) {
    const label = tile.querySelector('a.view');
    label.innerText = 'Listen now';
  }

  function dispatchTileUpdates(tile) {
    getHighResImage(tile);
    updateLabelPosition(tile);
    updateShareAndLabel(tile);

    if (document.querySelector('body').classList.contains('stream-5435792')) {
      truncateText(tile);
    }

    if (tile.dataset.tags !== undefined) {
      handleCustomerStoryTile(tile);
    }

    if (tile.getAttribute('data-source-stream-id') && tile.getAttribute('data-source-stream-id') === "4914622") {
      handlePodcastTile(tile);
    }

    tile.dataset.looped = true;
  }

  function init() {
    const validTiles = [...document.querySelectorAll('.tile:not([data-looped]):not(#loading-notifier):not(.cta)')];

    for (let i = 0; i < validTiles.length; i++) {
      dispatchTileUpdates(validTiles[i]);
    }
  }

  return init();
}

module.exports = handleTileUpdates;


// WEBPACK FOOTER //
// ./modules/handleTileUpdates.js